// extracted by mini-css-extract-plugin
export default {"page_navigation":"PageNavigation_page_navigation__Br9LG","page_navigation__item":"PageNavigation_page_navigation__item__VHUeX"};